import React, { useEffect, useState } from "react";
import { http } from "@/lib/api";
import { Link } from "react-router-dom";
import { Calendar, Image as ImageIcon, Users, DollarSign } from "lucide-react";

export default function AdminDashboard() {
  const [stats, setStats] = useState({ bookings: 0, media: 0, users: 0, revenue: 0 });

  useEffect(() => {
    (async () => {
      try {
        const [b, m, u] = await Promise.all([
          http.get("/admin/bookings"),
          http.get("/media"),
          http.get("/admin/users"),
        ]);
        const revenue = b.data
          .filter((x) => x.payment_status === "paid")
          .reduce((acc, x) => acc + (x.deposit_amount || 0), 0);
        setStats({
          bookings: b.data.length,
          media: m.data.length,
          users: u.data.length,
          revenue,
        });
      } catch {}
    })();
  }, []);

  const cards = [
    { label: "Bookings", value: stats.bookings, icon: Calendar, link: "/admin/bookings", accent: "#FF1493" },
    { label: "Photos & Videos", value: stats.media, icon: ImageIcon, link: "/admin/media", accent: "#FFB5D3" },
    { label: "Members", value: stats.users, icon: Users, link: "/admin/bookings", accent: "#E5B299" },
    { label: "Deposits Collected", value: `$${stats.revenue.toFixed(0)}`, icon: DollarSign, link: "/admin/bookings", accent: "#FF1493" },
  ];

  return (
    <div data-testid="admin-dashboard">
      <div className="mb-8">
        <div className="text-[10px] tracking-[0.3em] uppercase text-pink-blush mb-2">Welcome back</div>
        <h1 className="font-display text-4xl lg:text-5xl text-champagne">
          Your <span className="italic text-pink-hot">kingdom</span>
        </h1>
      </div>
      <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4 mb-8">
        {cards.map((c) => (
          <Link
            key={c.label}
            to={c.link}
            className="glass-panel rounded-md p-6 hover:border-pink-hot/50 transition-all"
          >
            <c.icon className="w-6 h-6 mb-3" style={{ color: c.accent }} />
            <div className="text-[10px] tracking-[0.3em] uppercase text-champagne/60 mb-2">{c.label}</div>
            <div className="font-display text-3xl text-champagne">{c.value}</div>
          </Link>
        ))}
      </div>

      <div className="glass-panel rounded-md p-8">
        <div className="font-display text-2xl italic text-pink-hot mb-3">Quick Tips</div>
        <ul className="text-sm text-champagne/80 space-y-2 list-disc list-inside">
          <li>Upload new photos & videos anytime from <strong className="text-pink-blush">Photos & Videos</strong>.</li>
          <li>Mark items as <strong className="text-pink-blush">Premium</strong> to lock them to subscribers.</li>
          <li>Update your bio, stats and policy from <strong className="text-pink-blush">About / Bio</strong>.</li>
          <li>Rates and deposits can be edited in <strong className="text-pink-blush">Rates</strong>.</li>
          <li>Bookings with paid deposits are automatically confirmed.</li>
        </ul>
      </div>
    </div>
  );
}
